import React from 'react';
export function FinalCTA() {
  return <section className="py-10 md:py-16 px-4 bg-[#c8b89a] text-[#0a0a0a] text-center relative overflow-hidden" data-id="element-28">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/aged-paper.png')]" data-id="element-29"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-30">
        <h2 className="text-3xl md:text-5xl font-bold mb-4 font-['Special_Elite'] leading-tight" data-id="element-31">
          El asesino cree que el tiempo ha borrado sus huellas.
        </h2>
        <p className="text-xl md:text-2xl font-bold mb-6 opacity-80 max-w-2xl mx-auto" data-id="element-32">
          La policía ya ha archivado los documentos. La única esperanza de estas
          víctimas eres tú.
        </p>

        <h3 className="text-2xl md:text-3xl font-bold text-[#cc2200] mb-8 font-['Special_Elite'] uppercase" data-id="element-33">
          ¿Aceptas el caso, Detective?
        </h3>

        <a href="https://www.mododetective.store/cart/47848790524118:1" className="bg-[#0a0a0a] text-white text-xl md:text-3xl font-bold py-6 px-10 rounded-sm shadow-2xl hover:bg-[#222] transition-all transform hover:-translate-y-1 border-2 border-black uppercase font-['Special_Elite'] inline-block text-center" data-id="element-34">
          DESCARGAR PACK 4X1 Y EMPEZAR A INVESTIGAR
        </a>
      </div>
    </section>;
}